import feathers from '@feathersjs/feathers'
import socketio from '@feathersjs/socketio-client'
import auth from '@feathersjs/authentication-client'
import { hooks } from '@feathersjs/hooks'
import io from 'socket.io-client'
import BaseService from './feathers/services/baseService'

const socket = io('wss://chat.bristol.iql.ru', { transports: ['websocket'] })

const feathersClient = feathers()
    .configure(socketio(socket))
    .configure(auth({ storage: window.localStorage }))
    // .configure(hooks())

// feathersClient.use('users-chat/list', new BaseService)
// feathersClient.use('messages', new BaseService)
const usersChatService = feathersClient.service('users-chat')
const usersChatListService = feathersClient.service('users-chat/list')
const messagesService = feathersClient.service('messages')
const messagesTypeService = feathersClient.service('messages/:type/:typeId')
const messageTotalsService = feathersClient.service('messages/total-moderated')

export default feathersClient
//
// // Setting up feathers-vuex
// const {
//     makeServicePlugin,
//     makeAuthPlugin,
//     BaseModel,
//     models,
//     FeathersVuex
// } = feathersVuex(feathersClient, {
//     serverAlias: 'api', // optional for working with multiple APIs (this is the default value)
//     idField: '_id', // Must match the id field in your database table/collection
//     whitelist: ['$regex', '$options']
// })

export { feathersClient, usersChatListService, usersChatService,
    messagesService, messagesTypeService, messageTotalsService }
